// extracted by mini-css-extract-plugin
module.exports = {"body":"Products_body__VvIEO","filter":"Products_filter___AaZL","container":"Products_container__yh6C5","grid":"Products_grid__2lP11"};